module.exports = __webpack_public_path__ + "static/media/about_small.4eb36f77.jpg";